/**
 * When a hand edit of an accepted scene would replace most of it.
 * The same thresholds live in backend/services/scene_writing.py.
 *
 * More than 80% shorter, or a scene of at least 200 characters left
 * under 200. An ordinary edit of a shorter scene is not this case.
 */

export const ACCEPTED_SHRINK_FRACTION = 0.8;
export const ACCEPTED_SHRINK_MIN_CHARS = 200;

export function textChars(value) {
  return [...String(value ?? '')].length;
}

export function acceptedSceneShrinkNeedsConfirm(saved, next) {
  const before = textChars(saved);
  const after = textChars(next);
  if (!before || after >= before) return false;
  const removed = (before - after) / before;
  if (removed > ACCEPTED_SHRINK_FRACTION) return true;
  if (before >= ACCEPTED_SHRINK_MIN_CHARS && after < ACCEPTED_SHRINK_MIN_CHARS) return true;
  return false;
}
